module.exports = __webpack_public_path__ + "media/images/japan/location_arrow_4-0d875035760f96072e7034b697612d0e.svg";